import React from 'react';
import Header from '../../includes/Header';
import { Link } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';

const Error = () => {
    return (
        <>
            <Header />
            <ToastContainer
                position="top-right"
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                style={{ zIndex: 9999999999, position: 'fixed' }}
            />
            <div className="errorpage">
                <h1>404</h1>
                <h2>Oops! Page Not Found</h2>
                <p>The page you are looking for doesn’t exist or has been moved.</p>
                <Link to="/" className="btn btn-green">Go Home</Link>
            </div>
        </>
    );
}
export default Error